<h3 mat-dialog-title>{{data.headline | translate}}</h3>
<mat-dialog-content class="mat-typography">
  <p>{{data.content}}</p>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{"Close" | translate}}</button>
</mat-dialog-actions>
